import { ExpandLess, ExpandMore } from "@mui/icons-material";
import {
  Box,
  Collapse,
  Divider,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { memo, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { makeStyles } from "tss-react/mui";

const AppMenuItem = (props) => {
  const {
    name,
    Icon,
    link,
    menuOpen,
    items = [],
    currentOpenKey,
    setCurrentOpenKey,
  } = props;

  const location = useLocation();

  const { classes } = useStyles();
  const isExpandable = items.length > 0;

  const open = isExpandable && currentOpenKey[0] === name;
  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    if (isExpandable && items.some((item) => location.pathname === item.link)) {
      setCurrentOpenKey((prev) => (prev[0] === name ? prev : [name]));
    }
  }, [location.pathname, items, isExpandable, name, setCurrentOpenKey]);

  const handleClick = () => {
    if (isExpandable) {
      setCurrentOpenKey((prev) => (prev[0] === name ? [] : [name]));
    }
  };

  const MenuItemRoot = (
    <ListItemButton
      sx={{
        "&:hover .MuiListItemIcon-root": {
          color: "#1e70bf", // your hover color
        },
      }}
      // sx={{ pl: 2 + level * 2 }} // 👈 adds indent per level
      className={classes.menuItem}
      component={NavLink}
      to={isExpandable ? undefined : link}
      selected={!isExpandable && location.pathname === link}
      onClick={handleClick}
    >
      {!!Icon && !isMobile && !menuOpen ? (
        <>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              minWidth: 0,
              flexGrow: 1,
            }}
          >
            <Icon />
            <Typography
              variant="caption"
              sx={{
                textAlign: "center",
                textWrap: "initial",
              }}
            >
              {name}
            </Typography>
            {isExpandable && (open ? <ExpandLess /> : <ExpandMore />)}
          </Box>
        </>
      ) : (
        <>
          <ListItemIcon
            sx={{
              minWidth: 32,
              "&:hover": {
                color: "#1e70bf",
              },
            }}
          >
            <Icon />
          </ListItemIcon>
          <ListItemText primary={name} />
          {isExpandable && (open ? <ExpandLess /> : <ExpandMore />)}
        </>
      )}
    </ListItemButton>
  );

  const MenuItemChildren = isExpandable ? (
    <Collapse in={open} timeout="auto" unmountOnExit>
      <Divider />
      <List component="li" disablePadding sx={{ pl: menuOpen ? 3 : 0 }}>
        {items.map((item, index) => (
          <AppMenuItem
            {...item}
            key={index}
            menuOpen={menuOpen}
            currentOpenKey={currentOpenKey}
            setCurrentOpenKey={setCurrentOpenKey}
          />
        ))}
      </List>
      <Divider />
    </Collapse>
  ) : null;

  return (
    <>
      {MenuItemRoot}
      {MenuItemChildren}
    </>
  );
};

const useStyles = makeStyles()((theme) => ({
  menuItem: {
    margin: 10,
    borderRadius: 10,
    width: "auto",
  },
  itemIcon: {
    minWidth: 32, // reduce space between icon and text
  },
}));

export default memo(AppMenuItem);
